import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
    name: 'templatedAdded',
})
export class templatedAdded implements PipeTransform {
    transform(value: string, args: any[]): string {
        let element = args.find(x => x.id == value);
        return element?.itemLength ? element?.itemLength : 0;
    }
}
